export { EventDispatcher } from "@cogo/runtime-v2"
